<div class="main_container">
    <div class="col-md-12 d-flex align-items-center p-0">
        <h1 style="color: green">Consulta de Reportes</h1>
        <button
            class="btn btn-success ml-2 rounded-circle p-1 information-message d-flex align-items-center justify-content-center"
            (click)="mostrarTexto()">
            <i class="fas fa-question"></i>
        </button>
    </div>
    <div class="col-md-12 d-flex align-items-center p-0 pb-3">
        <a class="btn btn_color" (click)="descargarFicha()">
            Guía de lectura para el adecuado entendimiento de los reportes
        </a>
    </div>

    <!-- Selección de año -->
    <div class="year_card">
        <h2>Selecciona un año</h2>
        <div class="year_input" (click)="abrirModalAnio()">
            {{ anioSeleccionado || 'Selecciona un año' }}
        </div>
    </div>

    <!-- Cards de reportes -->
    <ng-container *ngFor="let reporte of reportes">
        <div
            class="report_card"
            *appPermiso="'ver_y_descargar_reporte_' + reporte.id + '_madr'">
            <div class="report_info">
                <h2>{{ reporte.titulo }}</h2>
                <p>
                    {{ reporte.descripcionConsulta }}
                </p>
            </div>

            <div>
                <button type="button" (click)="descargarReporte(reporte.id)">
                    Descargar
                </button>
            </div>
        </div>
    </ng-container>
</div>

<!-- Modal selección de año -->
<div *ngIf="mostrarModalAnio" class="modal_overlay">
    <div class="modal_anio">
        <div class="modal_header">
            <h2>Seleccionar año</h2>
            <button
                type="button"
                class="close_button"
                (click)="cerrarModalAnio()">
                ×
            </button>
        </div>
        <div class="modal_content">
            <label for="anioModal">Año:</label>
            <select id="anioModal" [(ngModel)]="anioTemporal">
                <option [ngValue]="null" disabled>Selecciona un año</option>
                <option *ngFor="let anio of anios" [ngValue]="anio">
                    {{ anio }}
                </option>
            </select>
        </div>
        <div class="modal_footer">
            <button
                type="button"
                class="continue_button"
                (click)="continuarAnio()"
                [disabled]="!anioTemporal">
                Continuar
            </button>
        </div>
    </div>
</div>
